// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"b277b464","94":"748dc770","120":"5fd73b88","126":"76ad42c3","171":"6b593b22","407":"f64f625c","432":"373bfaf5","532":"3bc9ed1e","674":"2d9ebbff","684":"e2c36e39","711":"aadd4346","744":"e0dafb7b","994":"cbc94931"}[chunkId] + ".chunk.js";
};